import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { VisaFormApi } from "../../../api/visa-form/visa-form.api";
import { VisaTypeApi } from "../../../api/visa-type/visa-type.api";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { alertActive, alertError, alertSuccess, swalError } from "../../../components/alert/swal";
import { VisaRequestFrontApi } from "../../../api/visa-request-front/visa-request-front.api";
import { dateToView } from "../../../utils/date.utils";
import { VisaRequestAdminApi } from "../../../api/visa-request-admin/visa-request-admin.api";
import _ from "lodash";
import StatusCustom from "../../../components/status/statusCustom";
import { renderStatus, STATUS_VISA } from "./enum/request-form.enum";
import saveAs from "file-saver";
import { RootState } from "../../../store/store";
import { checkPermission, permission_config } from "../../../utils/app.utils";
const ManageState = () => {

    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();
    const location = useLocation()
    const { id_visa_step } = location?.state
    const profile = useSelector((state: RootState) => state.profile.profile) as any;
    const permission: any[] = profile?.permission || [];
    const checkPermit: permission_config = checkPermission(`manage_request_${id_visa_step}`, permission)

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("ALL");

    const [data, setData] = useState<any[]>([]);
    const [visaType, setVisaType] = useState<any[]>([]);


    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [isChecks, setIsChecks] = useState<any[]>([]);
    const [isCheckAll, setIsCheckAll] = useState<string>("");
    const onCheck = (event: any, _: any) => {
        const { checked, value } = event;
        if (checked) {
            setIsChecks(prev => [...prev, Number(value)]);
        } else {
            setIsChecks(
                prev => prev.filter((x) => x !== Number(value))
            );
        }
    };
    const onCheckAll = (event: any) => {
        const { checked } = event;
        // const id = _.map(data, (i: any) => {
        //   return i?.id_service_ticket;
        // });
        const id = data
            ?.filter((item: any) => {
                const statusMatch = [STATUS_VISA.WAITING_RECEIVE_REQUEST].includes(item?.status_visa)
                // const splitMatch = status_service_ticket_job?.find((x) =>
                //   x.value.split(',').includes(item?.service_ticket_status)
                // )?.value === item?.service_ticket_status
                // const splitMatch = item
                return statusMatch;
            }).map((filteredItem) => filteredItem?.id_visa_request);
        if (checked) {
            setIsChecks(Array.from(new Set([...isChecks, ...id])));
        } else {
            setIsChecks([]);
            // setIsChecks(_.filter(isChecks, (i) => !_.includes(id, i)));
        }
    };
    const handleOnCheckAll = () => {
        const filterData = data;
        const hasSome = _.some(filterData, (i: any) =>
            _.some(isChecks, (j: number) => Number(i?.id_visa_request) === Number(j))
        );
        const hasAll = _.every(filterData, (i: any) =>
            _.some(isChecks, (j: number) => Number(i?.id_visa_request) === Number(j))
        );
        if (!_.isEmpty(isChecks) && !hasAll && hasSome)
            setIsCheckAll("indeterminate");
        else if (!_.isEmpty(isChecks) && hasAll) setIsCheckAll("checked");
        else setIsCheckAll("");
    };
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_service_ticket_2",
            disablePadding: false,
            label: "CHECKBOX",
            align: "end",
            disabled: !checkPermit?.isUpdate,
            values: [],
            indeterminate: isCheckAll === "indeterminate" && true,
            checked: isCheckAll === "checked" && true,
            disableDropdown: true,
            hiddenDropdown: true,
            onCheckAll: (event: any) => onCheckAll(event.target),
            width: 50,
            sortable: false,
        },

        {
            id: "id_comment", width: 120, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 400, align: "left", label: t("ประเภทคำร้อง")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 250, label: t("ผู้ส่ง")
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 250, label: t("วันที่ส่ง")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 241, label: t("สถานะ")
        },


        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 150, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            visa_form_name,
            status_visa,
            sent_date,
            id_visa_request,
            student_last_name,
            student_frist_name
        } = objData;

        const rowCheck = _.some(
            isChecks,
            (i: number) => Number(i) === Number(id_visa_request)
        );

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            rowSelect: rowCheck,
            columns: [
                {
                    option: "CHECKBOX",
                    align: "center",
                    label: id_visa_request,
                    disabled: !checkPermit.isUpdate && ![STATUS_VISA.WAITING_RECEIVE_REQUEST].includes(status_visa)
                },
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: visa_form_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: `${student_frist_name} ${student_last_name}`,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: sent_date ? dateToView(sent_date) : "-",
                },
                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: status_visa || "-",
                // },



                {
                    option: "COMPONENT",
                    align: "center",
                    component: <StatusCustom
                        disableMaxWidth
                        text={renderStatus(status_visa)}
                        type={renderStatus(status_visa)}
                    />,
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {/* <IconButton onClick={() => navigate(routeName.request_form.manage_request_form_detail.replace(':id', id_visa_form))}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
                        <OptionsButtonCustom
                            enableEdit={checkPermit?.isUpdate && [STATUS_VISA.WAITING_RECEIVE_REQUEST, STATUS_VISA.RECEIVE_REQUEST, STATUS_VISA.ACCEPTING_REQUEST, STATUS_VISA.WAITING_PAYMENT_VERIFICATION].includes(status_visa)}
                            enableView={checkPermit?.isView }
                            // enableDelete={status_visa === STATUS_VISA.WAITING_RECEIVE_REQUEST || status_visa === STATUS_VISA.RECEIVE_REQUEST || status_visa === STATUS_VISA.ACCEPTING_REQUEST}
                            onViewClick={() => navigate(routeName.request_form.manage_request_view.replace(':id', id_visa_request))}
                            onEditClick={() => navigate(routeName.request_form.manage_request_detail.replace(':id', id_visa_request))}
                            onDeleteClick={() => handleDeleteList(id_visa_request)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
            onCheck={(event) => onCheck(event.target, objData)}

        />;
    };

    const handleDeleteList = (id_visa_request: number) => {
        alertActive(t("ฟอร์มคำร้อง"), t("ต้องการลบฟอร์มคำร้อง ? "), undefined, undefined, async () => {
            dispatch(setLoading());
            await VisaRequestFrontApi.delete(id_visa_request).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ฟอร์มคำร้อง"), t("ฟอร์มคำร้อง เรียบร้อยแล้ว"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ฟอร์มคำร้อง"), t("ฟอร์มคำร้อง ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        if (id_visa_step) query = { ...query, id_visa_step: id_visa_step }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }

        dispatch(setLoading());
        await VisaRequestAdminApi.list(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate, id_visa_step])



    useEffect(() => {
        handleGetData()
    }, [handleGetData])

    useEffect(() => {
        handleOnCheckAll();
    }, [isChecks]);

    const getVisaType = async () => {
        const param = {
            page: 1,
            limit: 100
        }
        await VisaTypeApi.list(param).then((res) => {
            if (res.status < 300) {
                setVisaType(res.data?.data.items || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        getVisaType()
    }, [])

    const handleSubmit = async () => {

        const body: any = {
            keyword: keyword || undefined,
            start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : undefined,
            end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : undefined,
            is_check_all: isCheckAll === "checked",
            id_visa_step: id_visa_step,
            include_id_visa_requests: isCheckAll === "checked" ? [] : isChecks,
            exclude_id_visa_requests: isCheckAll === "checked" ? [] : []
        }

        dispatch(setLoading());
        await VisaRequestAdminApi.receive(body)
            .then((res) => {
                if (res.status < 300) {


                    alertSuccess(
                        "รับคำร้อง",
                        "รับคำร้อง เรียบร้อยแล้ว",
                        undefined,
                        () => {
                            // navigate(-1);
                            // setStep(step + 1)
                            handleGetData()
                        }
                    );
                }
            })
            .catch((error) => {
                console.log(error);
                swalError(error?.response?.data?.th || error?.response?.data?.message || "เกิดข้อผิดพลาด");

            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    const handleDownloadReport = async (type: string) => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        if (id_visa_step) query = { ...query, id_visa_step: id_visa_step }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }


        if (type) query = { ...query, type: type }
        dispatch(setLoading());
        await VisaRequestAdminApi.report(query).then((res) => {
            if (res.status < 300) {
                const data = res.data;
                const contentType = res.headers["content-type"];

                const blob_file = new Blob([data], { type: contentType })
                saveAs(blob_file, t("COMPLAINTS_MANAGE_DATA"))
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("COMPLAINTS_DOWNLOAD_FILE"), t("COMPLAINTS_DOWNLOAD_FAILED"))
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        visaType,
        status,
        set_status,
        handleSubmit,
        handleDownloadReport,
        checkPermit
    }
}

export default ManageState